import React from "react";
// import "./styles.css";

type Props = {};
type State = {
    doc: null;
    pages: null;
};

export class PDFDownload extends React.Component<Props, State> {
    static paths = ["/app/pdf/:doc_id"];
    static requiresAuth = true;

    constructor(props: Props) {
        super(props);
        this.state = {
            doc: null,
            pages: null,
        };
    }

    async componentDidMount() {
        await this.fetch();
    }

    async fetch() {}

    render() {
        return <div>show pdf</div>;
    }
}
